import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../images/pngs/Logo.png';
import { FaHome, FaSearch, FaArrowLeft } from 'react-icons/fa';
import SEO from '../../Components/utils/SEO';

export default function NotFound() {
  return (
    <div className="notFoundPage">
      <SEO title="Page not found" description="The page you are looking for does not exist." noIndex noFollow />
      <div className="notFoundContent">
        <div className="notFoundIllustration">
          <span className="notFoundCode">404</span>
          <div className="notFoundOrb notFoundOrb1" />
          <div className="notFoundOrb notFoundOrb2" />
          <div className="notFoundOrb notFoundOrb3" />
        </div>
        <img src={Logo} alt="Chocowi" className="notFoundLogo" />
        <h1 className="notFoundTitle">Page Not Found</h1>
        <p className="notFoundDescription">
          The page you're looking for doesn't exist or has been moved. Let's get you back on track.
        </p>
        <div className="notFoundActions">
          <Link to="/" className="notFoundBtn notFoundBtnPrimary">
            <FaHome size={18} /> Go to Home
          </Link>
          <Link to="/products-services" className="notFoundBtn notFoundBtnSecondary">
            <FaSearch size={18} /> Browse Products
          </Link>
          <button type="button" className="notFoundBtn notFoundBtnGhost" onClick={() => window.history.back()}>
            <FaArrowLeft size={18} /> Go Back
          </button>
        </div>
      </div>
    </div>
  );
}
